import React from 'react';
import NuevaCotizacion from '../components/NuevaCotizacion';

function CotizacionesContainer() {
  return (
    <NuevaCotizacion />
  );
}

export default CotizacionesContainer;
